<template>
    <div>
        <ul class="list-unstyled backup-codes bg-light rounded" data-test="backup-codes">
            <li v-for="code in codes" :key="code"><code>{{ code }}</code></li>
        </ul>
        <div class="code-actions">
            <button type="button" class="btn btn-outline-primary" data-test="codes-copy" @click.prevent="copy"><i class="far fa-copy mr-1" aria-hidden="true"></i>Copy codes</button>
            <button type="button" class="btn btn-outline-primary" data-test="codes-download" @click.prevent="download"><i class="far fa-download mr-1" aria-hidden="true"></i>Download .txt</button>
        </div>
    </div>
</template>

<script>
import { copyCodes, downloadCodes } from './mfaHelpers'

export default {
    props: {
        codes: {type: Array, required: true},
    },
    methods: {
        copy() {
            copyCodes(this.codes)
        },
        download() {
            downloadCodes(this.codes)
        },
    },
}
</script>

<style scoped>
.backup-codes {
    columns: 2;
    font-size: 1.1rem;
    padding: 0.75rem 1rem;
    margin-bottom: 0.75rem;
}
.code-actions {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
}
</style>
